module.exports = __webpack_public_path__ + "img/project2.001b9746.png";